import angular from 'angular';

import RwLocationSelectorDialogModule from './components/rw-location-selector-dialog/rw-location-selector-dialog-module';

import RwLocationSelectorComponent from './rw-location-selector-component';

export default angular
  .module('rw-location-selector', [
    RwLocationSelectorDialogModule.name,
  ])
  .component('rwLocationSelector', new RwLocationSelectorComponent());



// WEBPACK FOOTER //
// ./src/modules/utils/rw-location-selector/rw-location-selector-module.js